import { Box, CircularProgress } from '@mui/material'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

const DEFAULT_TARGET = '/phrase'

export const TabBridge = () => {
  const auth = useAuth()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const rawTarget = searchParams.get('target') ?? DEFAULT_TARGET
    const target = rawTarget.startsWith('/') ? rawTarget : DEFAULT_TARGET

    const deviceId = searchParams.get('deviceId') ?? ''
    const rhq = searchParams.get('rhq') ?? ''
    const salesCompany = searchParams.get('salesCompany') ?? ''

    if (deviceId) {
      auth.setDeviceId(deviceId)
    }
    if (rhq) {
      auth.setRhq(rhq)
    }
    if (salesCompany) {
      auth.setSalesCompany(salesCompany)
    }

    const nextParams = new URLSearchParams()
    if (deviceId) {
      nextParams.set('deviceId', deviceId)
    }
    const nextUrl = nextParams.toString() ? `${target}?${nextParams.toString()}` : target

    navigate(nextUrl, { replace: true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress />
    </Box>
  )
}
